module.exports = __webpack_public_path__ + "img/9.17f6a526.jpg";